import React from 'react';
import '../Services.css';
import Image1 from '../../Gemco-Website-Images/Services/maintenance_engineer.jpg';

const Service_five = () => {
  return (
    <div className='wp_sub_service'>
          <div className="container wp_sub_service_container">
              <div className="row wp_service_row">
                <div className="content-column">
                  <div className="inner-column wp_service_inner_column">
                    <div className='sec-title forseotitle wp_service_sec_title'>
                      <h1>Facility Maintenance — AMC</h1>
                      <p>Annual maintenance contracts for HVAC systems, electrical panels, and specialist civil
                        surfaces. Structured PPM programmes to protect asset value and ensure system
                        performance year-round.</p>
                        <ul>
                          <li className="service_list_item">PPM for chillers</li>
                          <li className="service_list_item">cooling towers</li>
                          <li className="service_list_item">pumps, AHUs, FCUs, VRF and split units</li>
                          <li className="service_list_item">Electrical panel and DB inspection and maintenance</li>
                          <li className="service_list_item">Minor overhauls and component replacements</li>
                          <li className="service_list_item">Troubleshooting and fault diagnosis</li>
                          <li className="service_list_item">Valve and actuator calibration and servicing</li>
                          <li className="service_list_item">AMC reports, job cards and maintenance documentation</li>
                          <li className="service_list_item">Marble and terrazzo floor maintenance under specialist AMC</li>
                        </ul>
                    </div>
                  </div>
                </div>
                <div className="image-column">
                  <img src={Image1} width="500" height="400" alt="" />
                </div>
              </div>
          </div>
        </div>
  )
}

export default Service_five